import { phrase } from '../messages/phrase.js';
import { ringDistance } from '../world/grid.js';
/**
 * When and where a wandering rare stands up, and when it leaves (ADR 0094).
 * The server alone rolls them (`RareHunt`); nothing is stored, so a restart
 * only starts every biome's wait again.
 *
 * Each biome is asked once every `RARE_CHECK_MS` while its rare is away and
 * rested: one time in five it appears. Past its rest, a rare is thus about
 * fifty minutes away on average, and no watch tells when.
 */
export const RARE_CHECK_MS = 10 * 60_000;
export const RARE_APPEAR_CHANCE = 0.2;
/** Its rest once it fell or left: never twice in the same half hour. */
export const RARE_REST_MS = 30 * 60_000;
/** Unfound this long, it goes; a fight in progress keeps it (`RARE_FIGHT_GRACE_MS`). */
export const RARE_LIFETIME_MS = 20 * 60_000;
export const RARE_FIGHT_GRACE_MS = 60_000;
/** A den with a player this close is in plain sight: the rare would pop up before their eyes. */
export const RARE_UNSEEN_RANGE = 15;
export function rareAppears(rng) {
    return rng() < RARE_APPEAR_CHANCE;
}
/** Whether a rare out this long goes back: not while someone struck it within the grace. */
export function rareLeaves(appearedAt, lastStruckAt, now) {
    if (now < appearedAt + RARE_LIFETIME_MS)
        return false;
    return lastStruckAt === null || now - lastStruckAt >= RARE_FIGHT_GRACE_MS;
}
/**
 * Where it stands up: one of its biome's dens drawn at random, out of every
 * player's sight when one is, else any. Undefined without a den.
 */
export function pickRareDen(dens, players, rng) {
    const seen = [...players];
    const unseen = dens.filter((den) => seen.every((player) => ringDistance(player, den) > RARE_UNSEEN_RANGE));
    const pool = unseen.length > 0 ? unseen : dens;
    return pool[Math.floor(rng() * pool.length)];
}
/** Told to the players of its region only: no place, the region is the hint. */
export function rareSighted(name, epithet, region) {
    return phrase('On dit que {rare}, {epithet}, rôde dans la région : {region}', {
        rare: name,
        epithet,
        region,
    });
}
export function rareGone(name) {
    return phrase('{rare} a disparu sans laisser de trace', { rare: name });
}
//# sourceMappingURL=rare-mobs.js.map